import { ItRoom } from "@domain/project/floorplan/zones/it-room";
import { FloorplanItemTextKonva } from "@project/floorplanner/konva/floorplan-item-text-konva";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { ZoneKonva } from "@project/floorplanner/konva/zones/zone-konva";
import Konva from "konva";
import { Group } from "konva/lib/Group";
import { Rect } from "konva/lib/shapes/Rect";

export class ItRoomKonva {
  static init(itRoom: ItRoom): Group {
    const parentGroup = new Group();

    const zoneGroup = new Group({
      x: itRoom.x,
      y: itRoom.y,
      height: itRoom.height,
      width: itRoom.width,
      rotation: itRoom.rotation,
      draggable: false,
    });

    const rect = new Rect({
      x: 0,
      y: 0,
      height: itRoom.height,
      width: itRoom.width,
      strokeEnabled: false,
      fill: "red",
      opacity: 0.3,
    });

    const borderRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: itRoom.width,
      height: itRoom.height,
      stroke: "#002766",
      strokeWidth: 4,
      opacity: 1,
    });

    const itemText = FloorplanItemTextKonva.init(itRoom);
    const text = FloorplanItemTextKonva.getText(itemText);
    ZoneKonva.setTextPosition(itemText, zoneGroup);
    ZoneKonva.scaleText(text, zoneGroup);

    zoneGroup.on("transformstart", () => {
      itemText.hide();
    });

    zoneGroup.on("transform", () => {
      zoneGroup.width(Math.max(5, zoneGroup.width() * zoneGroup.scaleX()));
      zoneGroup.height(Math.max(5, zoneGroup.height() * zoneGroup.scaleY()));

      rect.width(zoneGroup.width());
      rect.height(zoneGroup.height());
      borderRect.width(zoneGroup.width());
      borderRect.height(zoneGroup.height());

      zoneGroup.scaleX(1);
      zoneGroup.scaleY(1);
    });

    zoneGroup.on("transformend", () => {
      itRoom.updateForm(
        zoneGroup.width() * zoneGroup.scaleX(),
        zoneGroup.height() * zoneGroup.scaleY(),
        zoneGroup.rotation(),
        zoneGroup.x(),
        zoneGroup.y(),
      );
      ZoneKonva.scaleText(text, zoneGroup);
      ZoneKonva.setTextPosition(itemText, zoneGroup);
      const labelHidden = itemText.getAttr("labelHidden") === true;
      if (!labelHidden) {
        itemText.show();
      }
    });

    zoneGroup.on("dragmove", () => {
      ZoneKonva.setTextPosition(itemText, zoneGroup);
    });

    zoneGroup.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, itRoom);
    zoneGroup.add(rect);
    zoneGroup.add(borderRect);
    parentGroup.add(zoneGroup, itemText);
    return parentGroup;
  }

  static refreshSize(zone: ItRoom, zoneGroup: Group) {
    ZoneKonva.resizeZoneGroup(zoneGroup, zone.width, zone.height);
    this.refreshItemText(zone, zoneGroup);
  }

  static refreshItemText(zone: ItRoom, group: Group) {
    const text = group.getChildren()[1] as Group;
    const zoneGroup = group.getChildren()[0] as Konva.Group;
    zoneGroup.width(zone.width);
    zoneGroup.height(zone.height);
    FloorplanItemTextKonva.refreshText(zone, text);
    const textNode = FloorplanItemTextKonva.getText(text);
    ZoneKonva.scaleText(textNode, zoneGroup);
    ZoneKonva.setTextPosition(text, zoneGroup);
  }
}
